import React from 'react'

import { Portlet } from '_zari/core'

import MainForm from './mainForm'

const MainPage = () => {
  return (
    <Portlet>
      <Portlet.Header title='SOCIOS - HOJA' />
      <Portlet.Body>
        <MainForm />
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(MainPage)
